import { useContext } from "react"
import { IPlatformClient } from "./client"
import PlatformContext from "./context"

const usePlatform = (): IPlatformClient => useContext(PlatformContext)

export default usePlatform
